/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { combineReducers } from 'redux';
import { call } from 'redux-saga/effects';
import * as EntitledAssets from './entitledAssets';
import * as SubscriptionsFolders from './subscriptionsFolders';

// combine all the consuption reducers
export default combineReducers({
  entitledAssets: EntitledAssets.default,
  subscriptionsFolders: SubscriptionsFolders.default,
});

export const sagas = [call(EntitledAssets.saga), call(SubscriptionsFolders.saga)];
